import { NotificationEvent } from './notification.types';

export const NOTIFICATION_EVENT_TO_ICON_MAP: Partial<Record<NotificationEvent, string>> = {
  [NotificationEvent.NewConversation]: 'chat_bubble',
  [NotificationEvent.ConversationAssignment]: 'person_add',
  [NotificationEvent.PrivateMessageInConversation]: 'speaker_notes',
  [NotificationEvent.PublicMessageInConversation]: 'chat_bubble',
  [NotificationEvent.ConversationChangedToOpen]: 'cached',
  [NotificationEvent.ConversationChangedToSolved]: 'cached',
  [NotificationEvent.ConversationChangedToOnHold]: 'cached',
  [NotificationEvent.ConversationChangedToSnoozed]: 'cached',
  [NotificationEvent.ConversationChangedToClosed]: 'cached',
  [NotificationEvent.ConversationUnsnoozed]: 'cached',
  [NotificationEvent.Mention]: 'alternate_email',
  [NotificationEvent.ServiceLevelChanged]: 'alternate_email',
  [NotificationEvent.SignalScheduleStart]: 'assignment_ind',
};

export const NOTIFICATION_EVENT_TO_STATUS_ICON_MAP: Partial<
  Record<NotificationEvent, string>
> = {
  [NotificationEvent.ServiceLevelChanged]: 'badge',
  [NotificationEvent.SignalScheduleStart]: 'event_upcoming',
};
